import React from "react";

const UserLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12.417"
      height="13.112"
      viewBox="0 0 12.417 13.112"
      role="img"
    >
      <g
        id="Group_3045"
        data-name="Group 3045"
        transform="translate(-624.27 -292.023)"
      >
        <path
          id="Ellipse_1110"
          data-name="Ellipse 1110"
          d="M3-.9A3.9,3.9,0,1,1-.9,3,3.906,3.906,0,0,1,3-.9Zm0,6A2.1,2.1,0,1,0,.9,3,2.1,2.1,0,0,0,3,5.1Z"
          transform="translate(627.477 292.923)"
          fill="#4b9ce2"
        />
        <path
          id="Path_3887"
          data-name="Path 3887"
          d="M635.787,316.313a.9.9,0,0,1-.9-.9,4.409,4.409,0,1,0-8.817,0,.9.9,0,0,1-1.8,0,6.209,6.209,0,0,1,12.417,0A.9.9,0,0,1,635.787,316.313Z"
          transform="translate(0 -11.178)"
          fill="#4b9ce2"
        />
      </g>
    </svg>
  );
};

export default UserLogo;
